(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var jsonEl = document.querySelector('[data-wbp-json]');
    if (!jsonEl) return;

    var data;

    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var section = document.getElementById('wb-product-' + data.sectionId);
    if (!section || section.dataset.wbpInitialized === 'true') return;

    section.dataset.wbpInitialized = 'true';

    setupGallery(section, data);
    setupVariants(section, data);
    setupAddToCart(section);
    setupStickyBar(section);
    setupAccordions(section);
    setupFullscreen(section);
    setupBis(section);
    setupFade(section);
    setupDescToggle(section);
  }

  function setupGallery(section) {
    var slides = section.querySelector('[data-wbp-slides]');
    var prevBtn = section.querySelector('[data-wbp-prev]');
    var nextBtn = section.querySelector('[data-wbp-next]');
    var thumbs = section.querySelectorAll('[data-wbp-thumb]');
    var currentEl = section.querySelector('[data-wbp-current]');
    var totalEl = section.querySelector('[data-wbp-total]');
    var counterBox = section.querySelector('[data-wbp-counter]');

    if (!slides) return;

    var currentIndex = 0;
    var slideEls = section.querySelectorAll('[data-wbp-slide]');
    var total = slideEls.length;

    section.setAttribute('data-gallery-count', total);

    if (total <= 1 && counterBox) counterBox.style.display = 'none';
    if (total <= 1 && section.getAttribute('data-gallery-mode') === 'grid') {
      section.setAttribute('data-gallery-mode', 'stack');
    }
    if (total <= 0) return;

    if (totalEl) totalEl.textContent = total;

    function goTo(index) {
      if (index < 0 || index >= total) return;

      currentIndex = index;

      var target = slideEls[index];
      var left = target.offsetLeft;

      slides.scrollTo({
        left: left,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });

      updateControls();
    }

    function updateControls() {
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex === total - 1;
      if (currentEl) currentEl.textContent = currentIndex + 1;

      thumbs.forEach(function (thumb) {
        var idx = parseInt(thumb.getAttribute('data-wbp-thumb'), 10);
        thumb.classList.toggle('is-active', idx === currentIndex);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(currentIndex + 1);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.getAttribute('data-wbp-thumb'), 10));
      });
    });

    var scrollTimer = null;

    slides.addEventListener('scroll', function () {
      if (scrollTimer) return;

      scrollTimer = requestAnimationFrame(function () {
        scrollTimer = null;

        var slideWidth = slides.offsetWidth;
        if (slideWidth <= 0) return;

        var newIndex = Math.round(slides.scrollLeft / slideWidth);

        if (newIndex !== currentIndex && newIndex >= 0 && newIndex < total) {
          currentIndex = newIndex;
          updateControls();
        }
      });
    }, { passive: true });

    section._galleryGoTo = goTo;
    updateControls();
  }

  function setupFullscreen(section) {
    if (section.getAttribute('data-fullscreen') !== 'true') return;

    var modal = document.createElement('div');

    modal.className = 'wb-product__fs-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Image en plein écran');
    modal.innerHTML =
      '<button class="wb-product__fs-close" aria-label="Fermer">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
          '<path d="M18 6L6 18M6 6l12 12"/>' +
        '</svg>' +
      '</button>' +
      '<img class="wb-product__fs-img" src="" alt="">';

    document.body.appendChild(modal);

    var fsImg = modal.querySelector('.wb-product__fs-img');
    var closeBtn = modal.querySelector('.wb-product__fs-close');
    var slideEls = section.querySelectorAll('.wb-product__slide');

    slideEls.forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img) return;

      var btn = document.createElement('button');

      btn.className = 'wb-product__fs-btn';
      btn.setAttribute('aria-label', 'Ouvrir en plein écran');
      btn.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
          '<path d="M8 3H5a2 2 0 00-2 2v3m18 0V5a2 2 0 00-2-2h-3m0 18h3a2 2 0 002-2v-3M3 16v3a2 2 0 002 2h3"/>' +
        '</svg>';

      btn.addEventListener('click', function (event) {
        event.stopPropagation();

        var src = img.getAttribute('src') || '';
        var hiRes = src.indexOf('width=') !== -1 ? src.replace(/width=\d+/, 'width=2400') : src;

        fsImg.src = hiRes;
        fsImg.alt = img.alt || '';
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });

      slide.appendChild(btn);
    });

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';

      setTimeout(function () {
        if (!modal.classList.contains('is-open')) fsImg.src = '';
      }, 350);
    }

    closeBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  function setupVariants(section, data) {
    var product = data.product;
    var variantIdInput = section.querySelector('[data-wbp-variant-id]');
    var priceEl = section.querySelector('[data-wbp-price]');
    var compareEl = section.querySelector('[data-wbp-compare]');
    var atcBtn = section.querySelector('[data-wbp-atc]');
    var atcText = section.querySelector('[data-wbp-atc-text]');
    var atcPriceEl = section.querySelector('[data-wbp-atc-price]');
    var atcCompareEl = section.querySelector('[data-wbp-atc-compare]');
    var stockEl = section.querySelector('[data-wbp-stock]');
    var stockText = section.querySelector('[data-wbp-stock-text]');
    var stickyPrice = section.querySelector('[data-wbp-sticky-price]');
    var stickyCompare = section.querySelector('[data-wbp-sticky-compare]');
    var bisBlock = section.querySelector('[data-wbp-bis]');
    var dynamicBtn = section.querySelector('.wb-product__dynamic-btn');

    if (!product || !product.variants) return;

    var selectedOptions = [];
    var firstVariant = null;

    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === data.initialVariantId) {
        firstVariant = product.variants[i];
        break;
      }
    }

    if (firstVariant && firstVariant.options) {
      selectedOptions = firstVariant.options.slice();
    }

    setupCustomSelects(section);

    var optionBtns = section.querySelectorAll('[data-option-value]');

    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-unavailable')) return;

        var fieldset = btn.closest('[data-option-index]');
        if (!fieldset) return;

        var optionIndex = parseInt(fieldset.getAttribute('data-option-index'), 10);
        var value = btn.getAttribute('data-option-value');

        selectedOptions[optionIndex] = value;

        fieldset.querySelectorAll('[data-option-value]').forEach(function (button) {
          button.classList.toggle('is-selected', button.getAttribute('data-option-value') === value);
        });

        var customSelect = fieldset.querySelector('[data-wbp-custom-select]');
        var current = fieldset.querySelector('[data-wbp-select-current]');

        if (customSelect && current) {
          current.textContent = btn.getAttribute('data-option-label') || value;
          customSelect.classList.remove('is-open');

          var trigger = customSelect.querySelector('[data-wbp-select-trigger]');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }

        processVariantChange();
      });
    });

    function setupCustomSelects(scope) {
      var selects = scope.querySelectorAll('[data-wbp-custom-select]');

      selects.forEach(function (select) {
        var trigger = select.querySelector('[data-wbp-select-trigger]');
        if (!trigger) return;

        trigger.addEventListener('click', function () {
          var isOpen = select.classList.contains('is-open');

          closeAllSelects(scope);

          select.classList.toggle('is-open', !isOpen);
          trigger.setAttribute('aria-expanded', String(!isOpen));
        });
      });

      document.addEventListener('click', function (event) {
        if (!event.target.closest('[data-wbp-custom-select]')) {
          closeAllSelects(scope);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeAllSelects(scope);
        }
      });
    }

    function closeAllSelects(scope) {
      scope.querySelectorAll('[data-wbp-custom-select]').forEach(function (select) {
        select.classList.remove('is-open');

        var trigger = select.querySelector('[data-wbp-select-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    function processVariantChange() {
      var variant = findVariant(product.variants, selectedOptions);
      if (variant) updateVariant(variant);
      updateUnavailableOptions();
    }

    function findVariant(variants, options) {
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var match = true;

        for (var j = 0; j < options.length; j++) {
          if (variant.options[j] !== options[j]) {
            match = false;
            break;
          }
        }

        if (match) return variant;
      }

      return null;
    }

    function updateUnavailableOptions() {
      var fieldsets = section.querySelectorAll('[data-option-index]');

      fieldsets.forEach(function (fieldset) {
        var optionIndex = parseInt(fieldset.getAttribute('data-option-index'), 10);
        var buttons = fieldset.querySelectorAll('[data-option-value]');

        buttons.forEach(function (button) {
          var testOptions = selectedOptions.slice();
          testOptions[optionIndex] = button.getAttribute('data-option-value');

          var matchedVariant = findVariant(product.variants, testOptions);
          var unavailable = matchedVariant && matchedVariant.available === false;

          button.classList.toggle('is-unavailable', !!unavailable);
          button.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
        });
      });
    }

    function formatMoney(cents) {
      var format = data.moneyFormat || '{{amount}}';
      var value = cents / 100;
      var amount = value.toFixed(2).replace('.', ',');
      var amountNoDecimals = Math.round(value).toString();

      return format
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, value.toFixed(2));
    }

    function updateVariant(variant) {
      if (variantIdInput) variantIdInput.value = variant.id;

      var formattedPrice = formatMoney(variant.price);
      var hasPromo = variant.compare_at_price && variant.compare_at_price > variant.price;
      var formattedCompare = hasPromo ? formatMoney(variant.compare_at_price) : '';

      if (priceEl) priceEl.textContent = formattedPrice;
      if (stickyPrice) stickyPrice.textContent = formattedPrice;

      if (compareEl) {
        if (hasPromo) {
          compareEl.textContent = formattedCompare;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (stickyCompare) {
        if (hasPromo) {
          stickyCompare.textContent = formattedCompare;
          stickyCompare.style.display = '';
        } else {
          stickyCompare.style.display = 'none';
        }
      }

      if (atcPriceEl) atcPriceEl.textContent = formattedPrice;

      if (atcCompareEl) {
        if (hasPromo) {
          atcCompareEl.textContent = formattedCompare;
          atcCompareEl.style.display = '';
        } else {
          atcCompareEl.style.display = 'none';
        }
      }

      if (atcBtn && atcText) {
        var defaultText = atcBtn.getAttribute('data-atc-text-default') || atcText.textContent || 'AJOUTER AU PANIER';
        var soldText = atcBtn.getAttribute('data-atc-text-sold') || 'ÉPUISÉ';

        if (variant.available) {
          atcBtn.disabled = false;
          atcText.textContent = defaultText;

          if (bisBlock) bisBlock.style.display = 'none';
          if (dynamicBtn) dynamicBtn.style.display = '';
        } else {
          atcBtn.disabled = true;
          atcText.textContent = soldText;

          if (bisBlock) bisBlock.style.display = '';
          if (dynamicBtn) dynamicBtn.style.display = 'none';
        }
      }

      if (stockEl && stockText) {
        if (!variant.available) {
          stockEl.setAttribute('data-state', 'out');
          stockText.textContent = 'Rupture de stock';
        } else {
          var management = data.management[variant.id];
          var quantity = data.inventory[variant.id];

          if (management === 'shopify') {
            if (quantity <= 5) {
              stockEl.setAttribute('data-state', 'low');
              stockText.textContent = 'Plus que ' + quantity + ' en stock';
            } else if (quantity <= 15) {
              stockEl.setAttribute('data-state', 'medium');
              stockText.textContent = 'Stock limité';
            } else {
              stockEl.setAttribute('data-state', 'in');
              stockText.textContent = 'En stock';
            }
          } else {
            stockEl.setAttribute('data-state', 'in');
            stockText.textContent = 'En stock';
          }
        }
      }

      if (variant.featured_media && section._galleryGoTo) {
        var mediaId = variant.featured_media.id;
        var slideEls = section.querySelectorAll('[data-wbp-slide]');

        slideEls.forEach(function (slide, index) {
          if (parseInt(slide.getAttribute('data-media-id'), 10) === mediaId) {
            section._galleryGoTo(index);
          }
        });
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    if (firstVariant) {
      updateVariant(firstVariant);
      updateUnavailableOptions();
    }
  }

  function setupAddToCart(section) {
    var form = section.querySelector('.wb-product__buy form') || section.querySelector('form[action*="/cart/add"]');
    var atcBtn = section.querySelector('[data-wbp-atc]');
    var stickyAtc = section.querySelector('[data-wbp-sticky-atc]');
    var variantInput = section.querySelector('[data-wbp-variant-id]');
    var isAdding = false;

    if (!atcBtn) return;

    function setLoading(state) {
      isAdding = state;

      if (state) {
        atcBtn.classList.add('is-loading');
        atcBtn.setAttribute('aria-busy', 'true');
        if (stickyAtc) {
          stickyAtc.classList.add('is-loading');
          stickyAtc.setAttribute('aria-busy', 'true');
        }
      } else {
        atcBtn.classList.remove('is-loading');
        atcBtn.removeAttribute('aria-busy');
        if (stickyAtc) {
          stickyAtc.classList.remove('is-loading');
          stickyAtc.removeAttribute('aria-busy');
        }
      }
    }

    function triggerSuccess(btn) {
      if (!btn) return;

      btn.classList.remove('is-loading');
      btn.classList.add('is-success');
      btn.removeAttribute('aria-busy');

      setTimeout(function () {
        btn.classList.remove('is-success');
      }, 1800);
    }

    function buildFormData() {
      var formData = form ? new FormData(form) : new FormData();
      var idInput = form ? form.querySelector('[name="id"]') : null;
      var quantityInput = form ? form.querySelector('[name="quantity"]') : null;
      var selectedId = variantInput ? variantInput.value : (idInput ? idInput.value : '');

      if (!formData.get('id') && selectedId) {
        formData.append('id', selectedId);
      }

      if (!formData.get('quantity')) {
        formData.append('quantity', quantityInput && quantityInput.value ? quantityInput.value : '1');
      }

      return formData;
    }

    function addToCart() {
      if (isAdding || atcBtn.disabled || atcBtn.classList.contains('is-loading')) return;

      var formData = buildFormData();
      var variantId = formData.get('id');

      if (!variantId) return;

      setLoading(true);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json'
        }
      })
        .then(function (response) {
          return response.json().then(function (json) {
            if (!response.ok) {
              var message = json && (json.description || json.message) ? (json.description || json.message) : 'Erreur ajout panier';
              throw new Error(message);
            }

            return json;
          });
        })
        .then(function (addedItem) {
          return refreshCartDrawer(true).then(function (cart) {
            setLoading(false);
            triggerSuccess(atcBtn);
            triggerSuccess(stickyAtc);
            dispatchCartEvents(addedItem, cart);
          });
        })
        .catch(function (error) {
          setLoading(false);
          dispatchCartError(error);
        });
    }

    function handleSubmit(event) {
      if (event) event.preventDefault();
      addToCart();
    }

    if (form) {
      form.addEventListener('submit', handleSubmit);
    }

    var tag = (atcBtn.tagName || '').toLowerCase();
    var type = (atcBtn.getAttribute('type') || (tag === 'button' ? 'submit' : '')).toLowerCase();
    var isNativeSubmit = form && (tag === 'button' || tag === 'input') && type === 'submit' && atcBtn.form === form;

    if (!isNativeSubmit) {
      atcBtn.addEventListener('click', function (event) {
        event.preventDefault();
        addToCart();
      });
    }

    if (stickyAtc) {
      stickyAtc.addEventListener('click', function (event) {
        event.preventDefault();
        addToCart();
      });
    }
  }

  function refreshCartDrawer(openAfterUpdate) {
    return fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Impossible de récupérer le panier');
        return response.json();
      })
      .then(function (cart) {
        renderHeaderCart(cart);

        if (openAfterUpdate) {
          openHeaderCartDrawer();
        }

        return cart;
      });
  }

  function openHeaderCartDrawer() {
    var cartDrawer = document.getElementById('CartDrawer');
    var backdrop = document.getElementById('SiteBackdrop');
    var navDrawer = document.getElementById('NavDrawer');
    var searchOverlay = document.getElementById('SearchOverlay');

    if (navDrawer) navDrawer.classList.remove('is-open');
    if (searchOverlay) searchOverlay.classList.remove('is-open');
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-visible');
  }

  function closeHeaderCartDrawer() {
    var cartDrawer = document.getElementById('CartDrawer');
    var backdrop = document.getElementById('SiteBackdrop');

    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-visible');
  }

  function renderHeaderCart(cart) {
    updateCartBubble(cart);
    updateCartTotals(cart);
    renderCartItems(cart);
    updateCartShipping(cart);
    updateCartInstallments(cart);
    updateCartDelivery();
  }

  function updateCartBubble(cart) {
    var bubble = document.getElementById('CartBubble');
    if (!bubble) return;

    bubble.textContent = cart.item_count;
    bubble.style.display = cart.item_count > 0 ? 'flex' : 'none';
  }

  function updateCartTotals(cart) {
    var total = document.getElementById('CartTotal');
    var compare = document.getElementById('CartTotalCompare');
    var originalTotal = 0;

    if (total) total.textContent = formatCartMoney(cart.total_price);

    if (!compare) return;

    if (cart.items && cart.items.length) {
      cart.items.forEach(function (item) {
        originalTotal += item.original_line_price || item.final_line_price || item.line_price || 0;
      });
    }

    if (originalTotal > cart.total_price) {
      compare.textContent = formatCartMoney(originalTotal);
      compare.style.display = '';
    } else {
      compare.textContent = '';
      compare.style.display = 'none';
    }
  }

  function renderCartItems(cart) {
    var itemsWrap = document.getElementById('CartItems');
    if (!itemsWrap) return;

    if (!cart.items || !cart.items.length) {
      itemsWrap.innerHTML = '<div class="cart-empty">Votre panier est vide.</div>';
      return;
    }

    itemsWrap.innerHTML = cart.items.map(function (item, index) {
      var image = item.image || item.featured_image || '';
      var title = escapeHTML(item.product_title || item.title || 'Produit');
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? escapeHTML(item.variant_title) : '';
      var url = escapeAttribute(item.url || '#');
      var price = formatCartMoney(item.final_line_price || item.line_price || 0);
      var comparePrice = item.original_line_price && item.original_line_price > item.final_line_price
        ? '<span class="cart-price-compare">' + formatCartMoney(item.original_line_price) + '</span>'
        : '';

      return '' +
        '<div class="cart-item">' +
          '<a href="' + url + '" class="cart-item-img">' +
            (image ? '<img src="' + escapeAttribute(image) + '" alt="' + title + '">' : '') +
          '</a>' +
          '<div class="cart-item-info">' +
            '<div class="cart-item-top">' +
              '<div>' +
                '<a href="' + url + '" class="cart-item-title">' + title + '</a>' +
                (variant ? '<div class="cart-item-variant">' + variant + '</div>' : '') +
              '</div>' +
              '<div class="cart-item-prices">' +
                '<span class="cart-price">' + price + '</span>' + comparePrice +
              '</div>' +
            '</div>' +
            '<div class="cart-item-actions">' +
              '<div class="cart-qty">' +
                '<button type="button" class="cart-qty-btn" data-line="' + (index + 1) + '" data-qty="' + Math.max(0, item.quantity - 1) + '">−</button>' +
                '<input class="cart-qty-val" value="' + item.quantity + '" readonly>' +
                '<button type="button" class="cart-qty-btn" data-line="' + (index + 1) + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
              '</div>' +
              '<button type="button" class="cart-remove" data-line="' + (index + 1) + '">Retirer</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');

    itemsWrap.querySelectorAll('.cart-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeCartLine(Number(btn.getAttribute('data-line')), Number(btn.getAttribute('data-qty')));
      });
    });

    itemsWrap.querySelectorAll('.cart-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeCartLine(Number(btn.getAttribute('data-line')), 0);
      });
    });
  }

  function changeCartLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Impossible de modifier le panier');
        return response.json();
      })
      .then(function (cart) {
        renderHeaderCart(cart);
        dispatchCartEvents(null, cart);
      })
      .catch(function (error) {
        dispatchCartError(error);
      });
  }

  function updateCartShipping(cart) {
    var wrap = document.querySelector('.cart-progress-wrapper');
    if (!wrap) return;

    var threshold = Number(wrap.getAttribute('data-threshold') || 0);
    var fill = document.getElementById('ShippingFill');
    var text = document.getElementById('ShippingText');

    if (!threshold) return;

    var percent = Math.min(100, (cart.total_price / threshold) * 100);
    var remaining = Math.max(0, threshold - cart.total_price);

    if (fill) fill.style.width = percent + '%';

    if (text) {
      text.textContent = remaining <= 0
        ? 'Livraison offerte débloquée ✓'
        : 'Plus que ' + formatCartMoney(remaining) + ' pour la livraison offerte';
    }
  }

  function updateCartInstallments(cart) {
    var el = document.getElementById('InstallmentsText');
    if (!el) return;

    var divisor = Number(el.getAttribute('data-divisor') || 3);
    var template = el.getAttribute('data-template') || '';
    var span = el.querySelector('span');

    if (span && template) {
      span.textContent = template.replace('[prix]', formatCartMoney(cart.total_price / divisor));
    }
  }

  function updateCartDelivery() {
    var el = document.getElementById('DeliveryDate');
    if (!el) return;

    var min = Number(el.getAttribute('data-min') || 2);
    var max = Number(el.getAttribute('data-max') || 4);
    var template = el.getAttribute('data-template') || '';
    var span = el.querySelector('span');

    if (!span || !template) return;

    var d1 = new Date();
    var d2 = new Date();
    d1.setDate(d1.getDate() + min);
    d2.setDate(d2.getDate() + max);

    var opts = { day: 'numeric', month: 'short' };
    var f1 = d1.toLocaleDateString('fr-FR', opts);
    var f2 = d2.toLocaleDateString('fr-FR', opts);

    span.innerHTML = template
      .replace('[d1]', '<strong>' + f1 + '</strong>')
      .replace('[d2]', '<strong>' + f2 + '</strong>');
  }

  function dispatchCartEvents(addedItem, cart) {
    dispatchSafeEvent(document, 'cart:updated', {
      cart: cart,
      item: addedItem || null
    });

    dispatchSafeEvent(document, 'cart:refresh', {
      cart: cart,
      item: addedItem || null
    });

    if (addedItem) {
      dispatchSafeEvent(document, 'ajaxProduct:added', {
        product: addedItem,
        cart: cart
      });

      dispatchSafeEvent(document, 'product:added', {
        product: addedItem,
        cart: cart
      });
    }
  }

  function dispatchCartError(error) {
    dispatchSafeEvent(document, 'cart:error', {
      error: error
    });

    if (window.console && window.console.warn) {
      window.console.warn(error);
    }
  }

  function dispatchSafeEvent(target, name, detail) {
    var event;

    if (typeof window.CustomEvent === 'function') {
      event = new CustomEvent(name, {
        bubbles: true,
        detail: detail || {}
      });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(name, true, false, detail || {});
    }

    target.dispatchEvent(event);
  }

  function formatCartMoney(cents) {
    var currency = 'EUR';

    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      currency = window.Shopify.currency.active;
    }

    try {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: currency
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function escapeHTML(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function escapeAttribute(value) {
    return escapeHTML(value).replace(/`/g, '&#096;');
  }

  function setupStickyBar(section) {
    var stickyBar = section.querySelector('[data-wbp-sticky-bar]');
    var atcBtn = section.querySelector('[data-wbp-atc]');

    if (!stickyBar || !atcBtn) return;

    var ticking = false;

    function onScroll() {
      if (ticking) return;

      ticking = true;

      requestAnimationFrame(function () {
        ticking = false;

        var rect = atcBtn.getBoundingClientRect();

        if (rect.bottom <= 0) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function setupAccordions(section) {
    var toggleDescBtn = section.querySelector('[data-wbp-toggle-desc]');

    if (toggleDescBtn) {
      toggleDescBtn.addEventListener('click', function () {
        var descAccordion = section.querySelector('[data-acc-description]');

        if (descAccordion) {
          descAccordion.open = true;

          var y = descAccordion.getBoundingClientRect().top + window.scrollY - 80;

          window.scrollTo({
            top: y,
            behavior: prefersReduced ? 'auto' : 'smooth'
          });
        }
      });
    }
  }

  function setupDescToggle(section) {
    var btn = section.querySelector('[data-wbp-toggle-desc-inline]');
    if (!btn) return;

    var inner = section.querySelector('[data-wbp-desc-inner]');
    var full = section.querySelector('[data-wbp-desc-full]');

    if (!inner || !full) return;

    btn.addEventListener('click', function () {
      inner.style.display = 'none';
      full.style.display = 'block';
      btn.style.display = 'none';
    });
  }

  function setupBis(section) {
    var bisToggle = section.querySelector('[data-wbp-bis-toggle]');
    var bisForm = section.querySelector('[data-wbp-bis-form]');

    if (!bisToggle || !bisForm) return;

    bisToggle.addEventListener('click', function () {
      bisForm.style.display = 'block';
      bisToggle.style.display = 'none';
    });
  }

  function setupFade(section) {
    var fadeEls = section.querySelectorAll('.wb-fade');

    if (!fadeEls.length) return;

    if (prefersReduced) {
      fadeEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -32px 0px'
    });

    fadeEls.forEach(function (el, index) {
      if (!el.style.transitionDelay) {
        el.style.transitionDelay = Math.min(index * 0.05, 0.4) + 's';
      }

      observer.observe(el);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-wbp-json]')
      ? event.target
      : document;

    var jsonEl = section.querySelector('[data-wbp-json]');
    if (!jsonEl) return;

    var productSection = event.target.querySelector('.wb-product');

    if (productSection) {
      productSection.dataset.wbpInitialized = 'false';
    }

    init();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();